import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, OutlinedInputProps } from "@mui/material";
import { useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface Props extends OutlinedInputProps {
  error?: boolean;
  helperText?: string;
  autoComplete?: string;
  reactHookForm: UseFormRegisterReturn;
}

function PasswordInput({
  label,
  error,
  helperText,
  autoComplete,
  reactHookForm,
  ...props
}: Props) {
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword((show: boolean) => !show)

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <FormControl sx={{ width: '100%' }} variant="outlined" size="small">
      <InputLabel
        htmlFor={`form-${reactHookForm.name}`}
        required={props.required}
        error={error}
      >{label}</InputLabel>

      <OutlinedInput
        id={`form-${reactHookForm.name}`}
        type={showPassword ? 'text' : 'password'}
        label={label}
        error={error}
        size="small"
        aria-describedby="component-error-text"
        fullWidth={true}
        autoComplete={autoComplete}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? 'Esconder senha' : 'Mostrar senha'}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        {...reactHookForm}
      />

      <FormHelperText id="component-error-text" error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}

export default PasswordInput;